import Splide from '@splidejs/splide';
window.splide = Splide;
